import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import { SUPPORTED_LANGS } from '../i18n';
import './Topbar.css';

export default function Topbar({ crumbs = [], onBack, onLogout }) {
  const { t, i18n } = useTranslation();
  return (
    <header className="topbar">
      <div className="topbar-left">
        {onBack && (
          <button className="tb-back" onClick={onBack} aria-label={t('common.back')}>
            <Icon name="arrow-left" size={20} />
          </button>
        )}
        <div className="tb-brand">
          <svg className="tb-logo" viewBox="0 0 32 32" aria-hidden="true">
            <rect width="32" height="32" rx="8" fill="#16C47F" />
            <path d="M8 8h16a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-6l-5 4v-4H8a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3z" fill="#07241A" />
          </svg>
          Yunoo
          <span className="tb-chip">ADMIN</span>
        </div>
        {crumbs.length > 0 && (
          <nav className="tb-crumbs" aria-label={t('common.nav')}>
            {crumbs.map((c, i) => (
              <span className="tb-crumb" key={i}>
                <Icon name="chevron-right" size={15} />
                <b>{c}</b>
              </span>
            ))}
          </nav>
        )}
      </div>
      <div className="topbar-right">
        <select
          className="tb-lang"
          value={i18n.language}
          onChange={e => i18n.changeLanguage(e.target.value)}
          aria-label={t('common.language')}
        >
          {SUPPORTED_LANGS.map(lng => (
            <option key={lng} value={lng}>{t(`languages.${lng}`)}</option>
          ))}
        </select>
        {onLogout && (
          <button className="tb-out" onClick={onLogout}>
            <Icon name="logout" size={17} />
            {t('common.logout')}
          </button>
        )}
      </div>
    </header>
  );
}
